import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { sendQuickAlertsUrl } from "../../../../config";
import { Status } from "../../../../common/constants";
import api from "../../../../api";
import { RootState } from "../../../../store";
import { IInitialSliceState } from "../../../../common/types/commonTypes";

const SEND_QUICKALERTS: string = "sendQuickAlerts";

const initialState: IInitialSliceState = {
  status: null,
  error: null,
  reqId: null,
  msg: null,
};

export const sendQuickAlerts = createAsyncThunk(
  SEND_QUICKALERTS,
  async (payload, { rejectWithValue }) => {
    try {
      const response = await api.post(sendQuickAlertsUrl, payload);
      return response.data;
    } catch (error) {
      throw rejectWithValue(error);
    }
  }
);

const sendQuickAlertsSlice = createSlice({
  name: SEND_QUICKALERTS,
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(sendQuickAlerts.pending, (state) => {
        state.status = Status.PENDING;
        state.msg = null;
      })
      .addCase(sendQuickAlerts.fulfilled, (state, action) => {
        state.msg = action.payload.message;
        state.reqId = Math.random();
        state.status = Status.SUCCESS;
      })
      .addCase(sendQuickAlerts.rejected, (state, action) => {
        const errorPayload = action.payload as {
          response?: {
            data?: { error?: { message?: string }; message?: string };
          };
        };
        state.msg =
          errorPayload.response?.data?.error?.message ||
          errorPayload.response?.data?.message ||
          "Unknown error occurred";
        state.reqId = Math.random();
        state.status = Status.FAILED;
      });
  },
});

export const selector = (state: RootState) => state.sendQuickAlertsApi;

export default sendQuickAlertsSlice.reducer;
